import { useSWRNoRevalidate } from "@nova/swr"

export const useFullnameForUserId = (userId?: string) => {
    const payload = useSWRNoRevalidate(userId ? `/api/protobuf/user/${userId}` : null)
    return { ...payload, fullName: payload.data?.fullName as string | undefined }
}
